module.exports = __webpack_public_path__ + "media/mem_coupon_m.24923797.mp4";